import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Plus, Trash } from "@phosphor-icons/react";
import { Modal, Field } from "./Suppliers";
import { toast } from "sonner";

const ROLES = ["admin", "operator", "viewer"];
const EMPTY = { name: "", email: "", password: "", role: "operator" };

export default function Users() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY);

  const load = async () => setItems((await api.get("/users")).data);
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.post("/users", form);
      toast.success("User created");
      setOpen(false);
      load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  const remove = async (id) => {
    if (!window.confirm("Delete this user?")) return;
    try { await api.delete(`/users/${id}`); toast.success("Deleted"); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div className="space-y-6" data-testid="users-page">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-display text-4xl uppercase tracking-tighter">Users</h1>
          <p className="text-xs text-zinc-600 mt-1">Admin only · manage team access</p>
        </div>
        <button onClick={() => { setForm(EMPTY); setOpen(true); }} className="brut-btn brut-btn-primary px-4 py-2 inline-flex items-center gap-2" data-testid="add-user-btn">
          <Plus size={14} weight="bold" /> Add User
        </button>
      </div>

      <div className="brut-card overflow-x-auto">
        <table className="brut-table" data-testid="users-table">
          <thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Created</th><th></th></tr></thead>
          <tbody>
            {items.map((u) => (
              <tr key={u.id} data-testid={`user-row-${u.email}`}>
                <td className="font-bold">{u.name}</td>
                <td>{u.email}</td>
                <td><span className={`brut-tag ${u.role === "admin" ? "brut-tag-dark" : u.role === "operator" ? "brut-tag-yellow" : "brut-tag-white"}`}>{u.role}</span></td>
                <td className="font-mono-ui text-xs">{u.created_at ? new Date(u.created_at).toLocaleDateString() : "—"}</td>
                <td className="text-right">
                  <button onClick={() => remove(u.id)} className="brut-tag brut-tag-red" data-testid={`delete-user-${u.email}`}>
                    <Trash size={10} weight="bold" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {open && (
        <Modal title="New User" onClose={() => setOpen(false)}>
          <form onSubmit={save} className="space-y-3" data-testid="user-form">
            <Field label="Name" required value={form.name} onChange={(v) => setForm({ ...form, name: v })} testid="user-name" />
            <Field label="Email" type="email" required value={form.email} onChange={(v) => setForm({ ...form, email: v })} testid="user-email" />
            <Field label="Password" type="password" required value={form.password} onChange={(v) => setForm({ ...form, password: v })} testid="user-password" />
            <div>
              <label className="brut-label">Role *</label>
              <select required value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} className="brut-input mt-1" data-testid="user-role">
                {ROLES.map((r) => <option key={r} value={r}>{r}</option>)}
              </select>
            </div>
            <button type="submit" className="brut-btn brut-btn-primary px-4 py-2 mt-2" data-testid="save-user-btn">Create User</button>
          </form>
        </Modal>
      )}
    </div>
  );
}
